import { APIClient } from '@frontend/api-utils';

export class FunctionalityEnumClient extends APIClient {
    public static readonly endpoint = '/functionality-api/v1';

    public static async fetchFunctionalityTypes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/functionality-types`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchApplications(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/applications`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchFeatures(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/features`);
        return await this.handleResponse<string[]>(response);
    }
}
